import WizCo from '@webcarelbj/wizco'

export default defineNuxtPlugin({
  name: 'wizco',
  dependsOn: ['storyblok'],
  async setup(nuxtApp) {
    if (import.meta.server) {
      return
    }

    const config = await usePageConfig()
    if (config === undefined) {
      return
    }

    const { apiDomain, listApiDomain, apiDomainDecision, apiDomainProduct, wizcoAccessToken } = useRuntimeConfig().public

    nuxtApp.vueApp.use(WizCo, {
      storyblokVersion: config.storyblok.accessLevel,
      storyblokAccessToken: wizcoAccessToken,
      apiDomain,
      listApiDomain,
      disableStoryblokPlugin: true,
      apiDomainDecision,
      apiDomainProduct,
    })
  },
})
